var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82154 8.83764L0.698386 5.35921C0.577715 5.29178 0.477715 5.19577 0.408248 5.08066C0.338781 4.96554 0.302246 4.8353 0.302246 4.70276C0.302246 4.57022 0.338781 4.43997 0.408248 4.32486C0.477715 4.20974 0.577715 4.11374 0.698386 4.04631L5.82154 0.565758C5.94367 0.497835 6.08262 0.461675 6.22431 0.460949C6.36599 0.460222 6.50535 0.494955 6.62825 0.561622C6.75115 0.628289 6.8532 0.724516 6.92406 0.840534C6.99491 0.956553 7.03204 1.08823 7.03167 1.22221V2.5807C8.71397 2.5807 13.7609 2.5807 14.8824 11.0647C12.0786 6.29244 7.03167 6.82269 7.03167 6.82269V8.18119C7.03167 8.77507 6.35203 9.13352 5.82154 8.8387V8.83764Z",
    fill: "#6A6AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.6479530fcce9a010b0fbf44a0de4b3da.svg";
export { ForwardRef as ReactComponent };